<template>
    <div class="category-list">
        <div
            class="category-wrapper"
            v-for="category in categories"
            :key="category.index"
        >
            <div class="category-item">
                <a :href="category.url">
                    <div class="left-panel">
                        <div class="category-count">
                            {{ category.product_count }} {{ catalogTranslations.products.toLowerCase() ?? "products" }}
                        </div>
                        <div class="category-title">
                            {{ category.name }}
                        </div>
                    </div>
                </a>
                <div
                    class="right-panel"
                    v-if="category.children.length"
                >
                    <i class="icon-chevronright"></i>
                </div>
            </div>
            <div
                class="category-nested-wrapper"
                style="display: none"
            >
                <div
                    class="category-nested-list"
                    v-for="nested in category.children"
                    :key="nested.index"
                >
                    <div class="category-nested-item">
                        <a :href="nested.url">
                            <div class="left-panel">
                                <div class="category-count">
                                    {{ nested.product_count }}
                                    {{ catalogTranslations.products.toLowerCase() ?? "products" }}
                                </div>
                                <div class="category-title">
                                    {{ nested.name }}
                                </div>
                            </div>
                        </a>
                        <div
                            class="right-panel"
                            v-if="nested.children.length"
                        >
                            <i class="icon-chevronright"></i>
                        </div>
                    </div>
                    <div
                        class="category-nested-child-wrapper"
                        style="display: none"
                    >
                        <div
                            class="category-nested-child-list"
                            v-for="nestedChild in nested.children"
                            :key="nestedChild.index"
                        >
                            <div class="category-nested-child-item">
                                <a :href="nestedChild.url">
                                    <div class="left-panel">
                                        <div class="category-count">
                                            {{ nestedChild.product_count }}
                                            {{ catalogTranslations.products.toLowerCase() ?? "products" }}
                                        </div>
                                        <div class="category-title">
                                            {{ nestedChild.name }}
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import BoPoint from "js/frontend/components/bo-point.vue";
Vue.component("bo-point", BoPoint);

export default {
    components: { BoPoint },

    props: {
        products: {
            type: Array,
            default: "",
        },
        categories: {
            type: Array,
            default: "",
        },
        action: {
            type: String,
            default: "All",
        },
    },
    data() {
        return {
            currentUrl: null,
            actionType: this.action,
            generalTranslations: window.bo?.generalTranslations ?? {},
            catalogTranslations: window.bo?.catalogTranslations ?? {},
        };
    },
    computed: {
        totalAmount: function () {
            var sum = 0;
            this.products.forEach((e) => {
                sum += 1;
            });
            return sum;
        },
    },
    mounted() {
        var dropdownFirst = document.getElementsByClassName("category-item");

        for (i = 0; i < dropdownFirst.length; i++) {
            dropdownFirst[i].addEventListener("click", function () {
                this.lastElementChild.classList.toggle("activate");
                var dropdownContent = this.nextElementSibling;
                if (dropdownContent.style.display === "block") {
                    dropdownContent.style.display = "none";
                } else {
                    dropdownContent.style.display = "block";
                }
            });
        }

        var dropdownSecond = document.getElementsByClassName("category-nested-item");

        for (i = 0; i < dropdownSecond.length; i++) {
            dropdownSecond[i].addEventListener("click", function () {
                this.lastElementChild.classList.toggle("activate");
                var dropdownNestedContent = this.nextElementSibling;
                if (dropdownNestedContent.style.display === "block") {
                    dropdownNestedContent.style.display = "none";
                } else {
                    dropdownNestedContent.style.display = "block";
                }
            });
        }
    },
    methods: {
        showCategory() {
            this.actionType = "Category";
        },
        showAll() {
            this.actionType = "All";
        },
        openChild() {},
        // amountOfProducts(products) {
        //     var amount = 0;
        //     products.forEach((product) => {
        //         amount++;
        //     });
        //     return amount;
        // },
        // computeTotal(products) {
        //     var total = 0;
        //     products.forEach((product) => {
        //         total += product.qty * product.price;
        //     });
        //     return total.toFixed(2);
        // },
        // addQuantity(product) {
        //     product.qty++;
        //     this.calculateTotalPrice(product);
        //     return product;
        // },
        // minusQuantity(product) {
        //     if (product.qty > 1) {
        //         product.qty--;
        //     }
        //     this.calculateTotalPrice(product);
        //     return product;
        // },
        // calculateTotalPrice(product) {
        //     if (product.qty > 0) {
        //         return (product.qty * product.price).toFixed(2);
        //     }
        //     return 0;
        // },
        // deleteEvent: function (product) {
        //     this.products.splice(this.products.indexOf(product), 1);
        // },
        // handleResize() {
        //     this.windowSize.width = window.innerWidth;
        //     this.windowSize.height = window.innerHeight;
        // },
        // calculatePoint(productPrice) {
        //     return parseFloat(this.pointConfig.tier_multiplier) * productPrice * this.pointConfig.conversion_rate;
        // },
        // isCurrentUrl(url) {
        //     let currentUrl = window.location.href;
        //     let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
        //     let textId = text.split("#")[0];
        //     return textId == url;
        // },
        // hasParent(items) {
        //     // console.log(items);
        //     let currentUrl = window.location.href;
        //     let count = 0;
        //     items.forEach(function (e) {
        //         let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
        //         let textId = text.split("#")[0];
        //         let url = "category/" + e.id;
        //         // console.log(textId);
        //         // console.log(e.id);
        //         // console.log(e.id == textId);
        //         if (e.id == textId) {
        //             count += 1;
        //         }
        //     });
        //     if (count > 0) {
        //         return true;
        //     }
        // },
        // hasNestedParent(grandpa, parent, items) {
        //     let currentUrl = window.location.href;
        //     let count = 0;
        //     items.forEach(function (e) {
        //         let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
        //         let textId = text.split("#")[0];
        //         let url = "category/" + e.id;
        //         // console.log(e.id+'->'+e.parent_id+'->'+grandpa);
        //         if (e.id == textId) {
        //             count += 1;
        //         }
        //     });
        //     if (count > 0) {
        //         // let grandpaId = '#cate-'+grandpa;
        //         // // console.log(grandpaId);
        //         // $("#cate-7").css("display", "block");
        //         return true;
        //     }
        // },
        // hasGrandson(items) {
        //     // console.log(items);
        //     let currentUrl = window.location.href;
        //     let count = 0;
        //     items.forEach(function (e) {
        //         e.children.forEach((ex) => {
        //             let text = currentUrl.substr(currentUrl.indexOf("category/") + 9);
        //             let textId = text.split("#")[0];
        //             let url = "category/" + ex.id;
        //             if (e.id == textId) {
        //                 count += 1;
        //             }
        //         });
        //     });
        //     if (count > 0) {
        //         return true;
        //     }
        // },
    },
};
</script>
